import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import logo from '../../logo.png';

export const IntroModal = ({ onNext, isOpen }) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-md animate-in fade-in duration-300">
      <div className={`relative border rounded-2xl max-w-lg w-full p-6 md:p-8 shadow-2xl animate-in zoom-in-95 duration-300 ${theme === 'dark'
          ? 'bg-slate-800 border-cyan-500/30 shadow-cyan-500/10'
          : 'bg-white border-slate-200 shadow-slate-200/50'
        }`}>
        <div className="text-center">
          <div className="relative inline-block mb-4">
            <div className="absolute inset-0 bg-cyan-500/20 blur-xl rounded-full" />
            <img src={logo} alt="Logo" className="relative h-16 mx-auto drop-shadow-[0_0_12px_rgba(6,182,212,0.6)]" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent mb-4">
            Sobre o Projeto
          </h2>

          <div className={`text-sm leading-relaxed text-left space-y-4 mb-6 ${theme === 'dark' ? 'text-slate-300' : 'text-slate-600'}`}>
            <p>
              O Mapa Cultural tem o objetivo de catalogar e divulgar as riquezas culturais da nossa região, facilitando o acesso à informação sobre eventos, festivais e artistas locais.
            </p>
            <p>
              Este mapa é parte integrante de um projeto maior: um aplicativo de divulgação cultural do Piauí integrado a recomendações inteligentes por IA. Nele você poderá encontrar um mapa muito semelhante e ainda mais completo, chamado <strong>cocalizando</strong>, que será disponibilizado em breve.
            </p>
            <div className={`p-3 rounded-xl border text-xs leading-relaxed flex items-start gap-2.5 ${
              theme === 'dark'
                ? 'bg-rose-500/10 border-rose-500/30 text-rose-300'
                : 'bg-rose-50 border-rose-200 text-rose-800'
            }`}>
              <span className="text-base shrink-0 leading-none">💡</span>
              <p>
                Encontrou algum bug, lentidão ou problema no mapa? Nossa plataforma conta com um canal de reporte de erros. Caso perceba qualquer falha técnica ou inconsistência, informe nossa equipe pelo botão <strong>Reportar Erro</strong> para mantermos o sistema sempre otimizado.
              </p>
            </div>
          </div>

          <button
            onClick={onNext}
            className="w-full py-3.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold rounded-xl transition-all shadow-lg shadow-cyan-500/30 transform active:scale-[0.98] flex items-center justify-center gap-2"
          >
            Continuar
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
